export const VALIDATE_MENU_PATH_URL = 'users/validateMenuRights';

export const exclusionPatterns = [
  // old approval pages: redirected to My Approvals (/approvals/inbox)
  '/approvals/hr',
  '/approvals/finance',
  '/approvals/operation',
  '/approvals/assets',
  '/approval/',
  '/404',
  // ERP Academy guides: open to everyone signed in
  '/academy',
  '/activity-logs',
  '/employee/reports/',
  '/employee/allowance/add',
  '/employee/allowance/edit',
  '/employee/allowance/view',
  '/employee/employee-detail',
  '/employee/newEmployee',
  '/employee/editEmployee',
  '/missing-punch',
  '/job-opening',
  '/job-opening/details',
  '/config/control-config',
  '/config/ui-config',
  '/config/ui-config/marginSalesTable',
  '/file-upload/files',
  '/vendors/vendor-detail',
  '/vendors/pendingVendorDetail',
  '/vendors/editVendor',
  '/changePassword',
  '/vendors/editPendingVendorDetail',
  '/changePin',
  '/employee/wps/',
  '/vendors/addNewBDA',
  '/LicenseKeyDetails',

  '/payslip/entry/',
  '/payslip/entry/newEntry',
  '/SalesOrder/AddSalesOrder',
  '/SalesOrder/EditSalesOrder',
  '/SalesOrder/print',
  '/sales-order/print',
  '/purchase-order/add',
  '/purchase-order/edit',
  '/purchase-order/print',
  '/purchase-order/view',
  '/goods-receipt/view',
  '/cheque-print/print',
  '/product-master/view',
  '/customer-master/new',
  '/customer-master/view',
  '/vendor-master/new',
  '/vendor-master/view',
  '/new-listing/details',
  '/sales-plan/AddSalesPlan',
  '/sales-plan/SalesPlanDetails',
  '/sales-plan/EditSalesPlan',
  '/target-sales/Zone-target',
  '/hr/payroll-period',
  '/payroll-period',
  '/customer/excel-upload',
  '/customer-item-upload',
  // division heads have no menu right; the server checks who may see each review
  '/access-reviews',
  // document pages under a menu page: the API checks the page rights on every call
  '/procurement/requisitions/',
  '/procurement/goods-receipts/',
  '/procurement/purchase-returns/',
  '/sales/invoices/',
  '/sales/returns/',
  '/sales/price-change-requests/',
  '/sales/price-lists/',
  '/sales/quotations/',
  '/config/transaction-setup/',
  '/finance/journal-entries/',
  '/finance/customer-receipts/',
  '/finance/customer-cheques/',
  '/finance/issued-cheques/',
  '/finance/supplier-payments/',
  '/finance/supplier-statements/',
  '/finance/credit-limits/',
  '/approvals/inbox/',
  '/finance/customer-statements/',
  '/sales/pick-lists/',
  '/inventory/stock-transfers/',
  '/inventory/stock-adjustments/',
  '/inventory/stock-count/',
  '/warehouse/bins/',
  '/procurement/rfq/',
  '/procurement/import-shipments/',
];
